import styled from "styled-components";
import { ContentContainerBase } from "../../common/components";
import { Swiper } from "swiper/react";

export const ContentContainer = styled(ContentContainerBase)`
  padding-bottom: 20px;
  @media ${({ theme }) => theme.device.tablet} {
    padding-bottom: 40px;
  }
`;

export const ScrollContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: scroll;
  align-items: center;
`;

export const Grid = styled.div`
  display: grid;
  width: 100%;
  height: 100%;
  grid-template-rows: 45% 55%;
  grid-template-areas:
    "image-area"
    "detail-area";
  row-gap: 5px;
`;

export const DetailBox = styled.div`
  grid-area: detail-area;
  padding-left: 5px;
  padding-right: 5px;
`;

export const Slider = styled(Swiper)`
  grid-area: image-area;
  width: 100%; // width 반드시 주어야함
  height: 100%; // height 반드시 주어야함

  .swiper-pagination-bullet-active {
    background-color: #f44b59;
  }
`;

export const SlideImage = styled.img`
  /* width: 100%;
  height: 100%; */
  /* object-position: center;
  object-fit: contain; */
  // border-radius 주고 싶을때 해제
  /* border-radius: 12px !important;  */
`;

export const Buttons = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 10px;
  margin-top: 20px;
  @media ${({ theme }) => theme.device.tablet} {
    gap: 20px;
  }
`;

export const BarcodeBox = styled.div`
  -webkit-user-select: none;
  width: 50%;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  background-color: #f44b59;
  &:active {
    background-color: #e84661;
  }
  border-radius: 5px;
  @media ${({ theme }) => theme.device.tablet} {
    width: 650px;
    height: 100px;
  }
`;

export const ButtonIcon = styled.img`
  width: 30px;
  height: 30px;
  display: flex;
  background-color: none;
  @media ${({ theme }) => theme.device.tablet} {
    width: 40px;
    height: 40px;
  }
`;

export const CancelBox = styled.div`
  width: 50%;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  border: 2px solid #eaeaea;
  border-radius: 5px;
  @media ${({ theme }) => theme.device.tablet} {
    width: 650px;
    height: 100px;
  }
`;
